export const GETSPINTOSSRAPPORT = "GETSPINTOSSRAPPORT"
export const ADD_RAPPORT_SPINTOSS_SUCCESS ="ADD_RAPPORT_SPINTOSS_SUCCESS"
export const ADD_RAPPORT_SPINTOSS_FAILURE ="ADD_RAPPORT_SPINTOSS_FAILURE "